import React from 'react';

export default function useWillMount<T>(willMount: () => T) {
	const [result] = React.useState(() => willMount());
	return result;
}
